import routes from './router';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import {LocalizationProvider} from '@mui/x-date-pickers';
import { useRoutes } from 'react-router-dom';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon'

import ThemeProvider from './theme/ThemeProvider';
import { CssBaseline } from '@mui/material';

import React, { useEffect, useState } from 'react';
import { Provider } from 'mobx-react'

import { persist } from 'mst-persist'
import localForage from 'localforage'
import Store from './context/root/Store' 

import { ReactNotifications} from 'react-notifications-component'
import 'react-notifications-component/dist/theme.css';
import 'animate.css/animate.min.css';
import { toJS } from 'mobx';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Hotjar from '@hotjar/browser';

const store = Store.create({})

const App = () => {

  const content = useRoutes(routes);
  const [ loading, setLoading ] = useState(true)

  useEffect(() => {
    persist(`budz-cms-2.0`, store, {
      storage: localForage,
      jsonify: false,
    }).then(async res => {
      // Tokenized deep links (Slack "Reply in CMS"): ?st=<bearer token>
      // bootstraps a session when none exists; an existing session wins.
      const params = new URLSearchParams(window.location.search)
      const st = params.get('st')
      if (st) {
        if (!store.authStore.token) {
          await store.authStore.loginWithToken(st)
        }
        params.delete('st')
        const query = params.toString()
        window.history.replaceState({}, '', `${window.location.pathname}${query ? `?${query}` : ''}`)
      }

      setLoading(false)
      store.set('hydrated', true)
      if (store.authStore.token) {
        store.initializeBudz()
      }
    })

    Hotjar.init(3883262, 6, {
      debug: false
    });

  }, [])

  

  return (
      <Provider store={store}>
        { store.hydrated === true &&
            <ThemeProvider>
            <LocalizationProvider dateAdapter={AdapterLuxon}>
              <ReactNotifications />
              <ToastContainer />
              <CssBaseline />
              {content}
            </LocalizationProvider>
          </ThemeProvider>
        }
      </Provider>
  );
}
export default App;
